import MapPanel from './MapPanel';

export default MapPanel;
